import { ACTIVE_USER_WINDOW_MS } from '../../shared/config/constants'
import { t } from '../../shared/config/translations'

export function collectionRefreshHelpText(): string {
	return t('progress.importingHelp').replace(
		'%{days}',
		String(Math.round(ACTIVE_USER_WINDOW_MS / (24 * 60 * 60 * 1000))),
	)
}
